const p = (c, n) => ({
  ...c,
  ...n
}), e = (c, n) => {
  if (!(n != null && n.children)) {
    const i = {
      [n.page_id]: c
    };
    return n != null && n.children_template_page_id && (i[n.children_template_page_id] = c), i;
  }
  const a = Object.entries(n.children).map(([i, d]) => e(i, d)).reduce(p, {});
  return Object.entries(a).map(([i, d]) => ({ [i]: `${c}/${d}` })).reduce(p, { [n.page_id]: c });
};
export {
  e as getPageIdToPathFrom
};
